/**
 * Historia de `/nuestra-tienda`. Los datos son los del sitio viejo
 * (`/nosotros`): nada de fechas que el cliente no haya dado. Por eso la linea
 * de tiempo solo fecha la fundacion.
 */
const HITOS = [
  {
    cuando: '1955',
    titulo: 'La fundación',
    texto:
      'El inmigrante español Abelardo Caso Crespo abre la tienda en pleno barrio San Diego.',
  },
  {
    cuando: 'Después',
    titulo: 'La remodelación',
    texto: 'El hijo y los nietos del fundador encabezan la remodelación completa de la casa matriz.',
  },
  {
    cuando: 'Hoy',
    titulo: 'La misma casa',
    texto: 'Seguimos enfocados en abastecer a mueblistas, carpinteros, arquitectos y diseñadores.',
  },
];

export function HistoriaTienda() {
  return (
    <section className="tienda-seccion tienda-historia" aria-labelledby="historia">
      <div className="tienda-seccion-cab">
        <p className="presentacion-antetitulo">Nuestra historia</p>
        <h2 id="historia">Tres generaciones detrás del mostrador</h2>
      </div>
      <ol className="tienda-linea">
        {HITOS.map((hito) => (
          <li key={hito.titulo}>
            <span className="cuando">{hito.cuando}</span>
            <h3>{hito.titulo}</h3>
            <p>{hito.texto}</p>
          </li>
        ))}
      </ol>
    </section>
  );
}
